/** Rutas públicas de documentos legales (páginas HTML + PDF en /public/docs). */
export const LEGAL_DOCUMENT_URLS = {
  privacy: "/politica-de-privacidad",
  terms: "/terminos-y-condiciones",
  privacyPdf: "/docs/DECLARACION DE PRIVACIDAD.pdf",
  termsPdf: "/docs/Terminos y Condiciones.pdf",
  dataTreatmentPdf: "/docs/POLITICA TRATAMIENTO DE DATOS.pdf",
};

/**
 * Documentos del footer que todavía no tenemos (o que pueden cambiar).
 *
 * Se activan SIN tocar código de dos formas:
 *  1. Subiendo el PDF a `public/docs/` con el nombre EXACTO de `file`
 *     (en producción basta con subirlo al bucket en `/docs/`): el footer
 *     verifica en tiempo de ejecución que exista y sea un PDF.
 *  2. Definiendo `url` (ruta interna, p. ej. "/quienes-somos", o URL externa),
 *     que tiene prioridad sobre el archivo.
 * Mientras no haya ni archivo ni url, el enlace se muestra como texto sin clic.
 */
export const OPTIONAL_FOOTER_DOCUMENTS = [
  {
    key: "about",
    label: "¿Quiénes somos?",
    match: /qui[eé]nes\s+somos/i,
    file: "/docs/QUIENES SOMOS.pdf",
    url: "",
  },
  {
    key: "responsibleGaming",
    label: "Manual de Juego Responsable",
    match: /juego\s+responsable/i,
    file: "/docs/MANUAL JUEGO RESPONSABLE.pdf",
    url: "",
  },
  {
    key: "cookies",
    label: "Política de cookies",
    match: /cookies/i,
    file: "/docs/POLITICA DE COOKIES.pdf",
    url: "",
  },
  {
    key: "iso",
    label: "Certificación ISO",
    match: /certificaci[oó]n\s+iso|\biso\b/i,
    file: "/docs/CERTIFICACION ISO.pdf",
    url: "",
  },
];

/**
 * Sello ISO para la barra de logos del footer. Vacío a propósito: la empresa
 * aún no está certificada. Cuando lo esté, poner la imagen en
 * `public/images/` y su ruta en `image_url` (p. ej. "/images/iso-27001.png").
 */
export const ISO_CERTIFICATION_LOGO = {
  image_url: "",
  alt: "Certificación ISO",
};

export function findOptionalFooterDocument(label) {
  const text = String(label || "");
  return OPTIONAL_FOOTER_DOCUMENTS.find((doc) => doc.match.test(text)) || null;
}

/** Codifica la ruta (espacios → %20) sin doble codificar si ya venía codificada. */
export function toPublicAssetHref(path) {
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;
  let decoded = path;
  try {
    decoded = decodeURI(path);
  } catch {
    /* ruta con % sueltos: se codifica tal cual */
  }
  return encodeURI(decoded.startsWith("/") ? decoded : `/${decoded}`);
}

/**
 * Convierte enlaces legacy (/politicas, PDFs) o etiquetas a la URL HTML correcta.
 */
export function resolveLegalDocumentUrl(url, label = "") {
  const normalizedLabel = String(label).toLowerCase();
  const normalizedUrl = String(url || "").toLowerCase();

  if (
    normalizedLabel.includes("tratamiento") ||
    normalizedUrl.includes("tratamiento de datos") ||
    normalizedUrl.includes("tratamiento%20de%20datos") ||
    normalizedUrl.includes("politica tratamiento")
  ) {
    return toPublicAssetHref(LEGAL_DOCUMENT_URLS.dataTreatmentPdf);
  }
  if (normalizedLabel.includes("privacidad")) {
    return LEGAL_DOCUMENT_URLS.privacy;
  }
  if (
    normalizedLabel.includes("términos") ||
    normalizedLabel.includes("terminos") ||
    normalizedLabel.includes("condiciones")
  ) {
    return LEGAL_DOCUMENT_URLS.terms;
  }
  if (
    normalizedUrl === "/politicas" ||
    normalizedUrl.startsWith("/politicas") ||
    normalizedUrl.includes("politica de privacidad") ||
    normalizedUrl.includes("politica%20de%20privacidad") ||
    normalizedUrl.includes("declaracion de privacidad") ||
    normalizedUrl.includes("declaracion%20de%20privacidad")
  ) {
    return LEGAL_DOCUMENT_URLS.privacy;
  }
  if (
    normalizedUrl.includes("terminos y condiciones") ||
    normalizedUrl.includes("terminos%20y%20condiciones") ||
    normalizedUrl.includes("términos y condiciones")
  ) {
    return LEGAL_DOCUMENT_URLS.terms;
  }

  return url;
}

export function shouldOpenInNewTab(url) {
  if (!url) return false;
  const u = String(url);
  return (
    u.startsWith("http") ||
    u.includes("/docs/") ||
    /\.pdf$/i.test(u) ||
    u.includes("/politica-de-privacidad") ||
    u.includes("/terminos-y-condiciones")
  );
}
